import { render, staticRenderFns } from "./ProjectsTabs.vue?vue&type=template&id=fb752d06&scoped=true"
import script from "./ProjectsTabs.vue?vue&type=script&lang=js"
export * from "./ProjectsTabs.vue?vue&type=script&lang=js"
import style0 from "./ProjectsTabs.vue?vue&type=style&index=0&id=fb752d06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb752d06",
  null
  
)

export default component.exports